import { render, staticRenderFns } from "./Badminton.vue?vue&type=template&id=382be3a5&scoped=true"
import script from "./Badminton.vue?vue&type=script&lang=js"
export * from "./Badminton.vue?vue&type=script&lang=js"
import style0 from "./Badminton.vue?vue&type=style&index=0&id=382be3a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382be3a5",
  null
  
)

export default component.exports